import { cx } from './primitives';

/**
 * Aynı görsel, temaya göre iki dosya.
 *
 * ASYA markası iki renk taşıyor: lacivert (ton ~210°, parlaklık %22) ve altın.
 * Koyu temanın yüzeyi `hsl(217 33% 14%)` — yani laciverdin kendisi. Tek dosyayla
 * markanın lacivert olan her parçası (rozetteki "A", şeritteki ve künyedeki
 * "ASYA ASC HAVACILIK") zemine karışıp kayboluyor; geriye tek başına uçan altın
 * bir uçak kalıyor.
 *
 * CSS filtresi çözmez: `invert` altını maviye çevirir, `brightness` laciverdi
 * griye. Çözüm ikinci dosya — yalnızca lacivert aile koyu temanın metin
 * rengiyle değiştirilmiş, altın ve alfa kanalı olduğu gibi bırakılmış hâli.
 *
 * Burada duruyor çünkü iki çağıran var: uygulama başlığı ve giriş ekranı.
 * Başlıkta bulunup giriş ekranında bulunmaması, kusurun tam olarak yayına
 * çıkma biçimiydi — düzeltme bir ekranda yapıldı, en çok görülen ekranda
 * yapılmadı.
 *
 * `display:none` erişilebilirlik ağacından da düşürür, dolayısıyla `alt` iki
 * kopyada da durabilir: ekran okuyucu her zaman yalnızca görünen tekini görür.
 */
export function ThemedImage({
  light,
  dark,
  alt,
  className,
}: {
  light: string;
  dark: string;
  /** Boş dizge dekoratif demektir; o hâlde `aria-hidden` de eklenir. */
  alt: string;
  className: string;
}) {
  const decorative = alt === '';
  return (
    <>
      <img
        src={light}
        alt={alt}
        aria-hidden={decorative || undefined}
        className={cx(className, 'dark:hidden')}
      />
      <img
        src={dark}
        alt={alt}
        aria-hidden={decorative || undefined}
        className={cx(className, 'hidden dark:block')}
      />
    </>
  );
}
